// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2mRuG","modalFooterButton":"ModalNotes_modalFooterButton__ynrZY"};